<script lang="ts">
  import { EditorJs } from 'query-strapi-v4';
  type Block = $$Generic<EditorJs.List | undefined>;
  export let block = undefined as Block;
  import { findReplaceLinksInText } from './handle-links';
  import { v4 as uuidv4 } from 'uuid';
  import { cn } from '$lib/utils';

  const tag = block?.data?.style === 'ordered' ? 'ol' : 'ul';
  const cleanText = (text: string) => {
    const replacedTextWithLinks = findReplaceLinksInText(text);
    const codeRegex = /<code class="inline-code">(.*?)<\/code>/g;
    const replacedCode = replacedTextWithLinks.replace(
      codeRegex,
      '<code class="relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold">$1</code>'
    );
    // also replace <mark class="bg-muted-foreground/50 font-semibold"> with <mark class="bg-muted font-semibold text-foreground">
    const markRegex = /<mark class="cdx-marker">(.*?)<\/mark>/g;
    const replacedMark = replacedCode.replace(
      markRegex,
      '<mark class="bg-muted font-semibold text-foreground">$1</mark>'
    );
    return replacedMark;
  };
</script>

{#if block?.data?.items?.length}
  <svelte:element
    this={tag}
    class={cn('my-6 ml-6 [&>li]:mt-2', {
      'list-decimal': block.data.style === 'ordered',
      'list-disc': block.data.style === 'unordered'
    })}
  >
    {#each block.data.items as item (uuidv4())}
      <li>
        {@html cleanText(item)}
      </li>
    {/each}
  </svelte:element>
{/if}
